import { IngotIcon } from "@/ingot";

import { cx } from "@/lib/utils";

/** One tick card — the design's single visual grammar for every choice. */
export function PickCard({
  on,
  onClick,
  title,
  sub,
  meta,
  testId,
  radio = false,
}: {
  on: boolean;
  onClick: () => void;
  title: string;
  sub?: string;
  meta?: string;
  testId?: string;
  /** KAN-2014 — výlučná volba (jedna z několika): radio, ne zaškrtávátko. */
  radio?: boolean;
}): React.ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      // KAN-1032: vybranou kartu poznal jen ten, kdo VIDÍ rámeček.
      role={radio ? "radio" : undefined}
      aria-checked={radio ? on : undefined}
      aria-pressed={radio ? undefined : on}
      className={cx("pick", on && "is-on")}
    >
      <span className={cx("pick-mark", radio && "is-radio", radio && on && "is-on")}>
        {on && !radio ? <IngotIcon name="check" size={13} /> : null}
      </span>
      <span className="pick-body">
        <span className="pick-title">
          {title}
          {meta ? <em>{meta}</em> : null}
        </span>
        {sub ? <span className="pick-sub">{sub}</span> : null}
      </span>
    </button>
  );
}
